import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../api';

// Previous / next record of the same pharmacy for a detail page (pairs with RecordNav):
// loads `${endpoint}` → { previousId, nextId } whenever the id changes, navigates with
// buildPath(targetId), and wires the ← / → keys (ignored while typing or with a modal open).
export default function useRecordNeighbors(endpoint, buildPath) {
  const navigate = useNavigate();
  const [neighbors, setNeighbors] = useState({ previousId: null, nextId: null });

  useEffect(() => {
    setNeighbors({ previousId: null, nextId: null });
    axios.get(`${API_BASE_URL}${endpoint}`, { withCredentials: true })
      .then(r => setNeighbors(r.data || {}))
      .catch(() => {});
  }, [endpoint]);

  const goTo = useCallback((targetId) => {
    if (targetId) navigate(buildPath(targetId));
  }, [navigate, buildPath]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      const el = document.activeElement;
      if (el && (el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName))) return;
      if (document.querySelector('.rm-overlay')) return;
      const isRtl = document.documentElement.dir === 'rtl';
      const goPrevious = (e.key === 'ArrowLeft') !== isRtl;
      goTo(goPrevious ? neighbors.previousId : neighbors.nextId);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [neighbors, goTo]);

  return { neighbors, goTo };
}
